var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { IfFeatureFlagOn } from 'components/shared/featureFlag';
import styles from './automationDotsMenu.module.scss';
export class AutomationDotsMenu extends PureComponent {
    gotoAutomationFlow() {
        const { automationId, gotoAutomationFlow } = this.props;
        analytics.automationsOptionsMenuOptionFlowClicked();
        gotoAutomationFlow(automationId);
    }
    gotoAuditLogs() {
        const { automationId, gotoAuditLogs } = this.props;
        analytics.automationsFlowOptionsMenuOptionAuditLogClicked();
        gotoAuditLogs(automationId);
    }
    showSettingsModal() {
        const { automationId, showSettingsModal } = this.props;
        analytics.automationsOptionsMenuOptionSettingsClicked();
        showSettingsModal(automationId);
    }
    duplicateAutomation() {
        const { automationId, duplicateAutomation } = this.props;
        analytics.automationsOptionsMenuOptionDuplicateClicked();
        duplicateAutomation(automationId);
    }
    deleteAutomation() {
        const { automationId, deleteAutomation } = this.props;
        analytics.automationsOptionsMenuOptionDeleteClicked();
        deleteAutomation(automationId);
    }
    onToggleMenu(isOpen) {
        if (isOpen) {
            analytics.automationsOptionsMenuOpened();
        }
    }
    render() {
        return (_jsx(DropdownButton, { icon: "dots-h", fixed: true, buttonProps: { variant: 'tertiary' }, noArrow: true, onToggle: this.onToggleMenu, dropdown: _jsxs(ButtonList, Object.assign({ className: styles.actionsList }, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: this.gotoAutomationFlow }, { children: "Edit flow" })), _jsx(ButtonList.Item, Object.assign({ onClick: this.showSettingsModal }, { children: "Rename" })), _jsx(ButtonList.Item, Object.assign({ onClick: this.duplicateAutomation }, { children: "Duplicate" })), _jsx(IfFeatureFlagOn, Object.assign({ name: "routing-audit-log-automations" }, { children: _jsx(ButtonList.Item, Object.assign({ onClick: this.gotoAuditLogs }, { children: "See audit log" })) })), _jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ onClick: this.deleteAutomation, buttonClassName: styles.delete }, { children: "Delete" }))] })) }));
    }
}
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "gotoAutomationFlow", null);
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "gotoAuditLogs", null);
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "showSettingsModal", null);
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "duplicateAutomation", null);
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "deleteAutomation", null);
__decorate([
    boundMethod
], AutomationDotsMenu.prototype, "onToggleMenu", null);
